import { useMutation, useQueryClient } from '@tanstack/react-query'

import { queryKey as queryKeyGeblokkeerdeWeken } from '../../../entity/planning/hooks/useGeblokkeerdeWekenForEntity'
import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey as queryKeyActiviteiten } from '../hooks/useSearchActiviteitenForEntity'
import { cancelActiviteitForEntity } from '../services/cancelActiviteitForEntity'

export { useCancelActiviteitForEntity }

const useCancelActiviteitForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: cancelActiviteitForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyActiviteiten] })
      queryClient.invalidateQueries({ queryKey: [queryKeyGeblokkeerdeWeken] })
      successAlert('Activiteit successvol geannuleerd')
    },
  })
}
